import { audioContext, masterTrack } from '../../webAudio/audioContext';
import { crossFadeOutputTypes } from './constants';

const mixer = {
   tracks: [],
   crossFader: {
      reference: audioContext.createGain(),
      user: audioContext.createGain(),
   },
};

{
   const now = audioContext.currentTime;
   mixer.crossFader.reference.gain.setValueAtTime(0, now);
   mixer.crossFader.reference.connect(masterTrack.in);
   mixer.crossFader.user.connect(masterTrack.in);
}

const setCrossfadeOutput = (outputType) => {
   const now = audioContext.currentTime;
   let oldReferenceGain;
   let newReferenceGain;
   let oldUserGain;
   let newUserGain;

   if (outputType === crossFadeOutputTypes.reference) {
      // switch to reference
      oldReferenceGain = 0;
      newReferenceGain = 1;
      oldUserGain = 1;
      newUserGain = 0;
   } else if (outputType === crossFadeOutputTypes.user) {
      // switch to user
      oldReferenceGain = 1;
      newReferenceGain = 0;
      oldUserGain = 0;
      newUserGain = 1;
   }

   mixer.crossFader.reference.gain.setValueAtTime(oldReferenceGain, now);
   mixer.crossFader.reference.gain.linearRampToValueAtTime(
      newReferenceGain,
      now + 0.02
   );

   mixer.crossFader.user.gain.setValueAtTime(oldUserGain, now);
   mixer.crossFader.user.gain.linearRampToValueAtTime(newUserGain, now + 0.02);
};

if (process.env.NODE_ENV === 'development') {
   window.mixer = mixer;
}

export { mixer, setCrossfadeOutput };
